import http from "./http-service";
import { DATA_DELETION } from "./endpoint-urls";
import {
  IDataDeletionLog,
  IPartnerDeletionPreview,
  IUserDeletionPreview,
} from "interfaces/data-deletion.interface";

export const previewPartnerDeletion = (id: string, deletePartnerRecord: boolean) => {
  return http
    .get<IPartnerDeletionPreview>(
      `${DATA_DELETION}/partners/${id}?delete_partner_record=${deletePartnerRecord}`
    )
    .then((res) => res.data);
};

export const deletePartnerData = (
  id: string,
  confirmName: string,
  deletePartnerRecord: boolean
) => {
  return http
    .post<IDataDeletionLog>(`${DATA_DELETION}/partners/${id}`, {
      confirm_name: confirmName,
      delete_partner_record: deletePartnerRecord,
    })
    .then((res) => res.data);
};

export const previewUserDeletion = (id: string) => {
  return http
    .get<IUserDeletionPreview>(`${DATA_DELETION}/users/${id}`)
    .then((res) => res.data);
};

export const deleteUserData = (id: string, confirmEmail: string) => {
  return http
    .post<IDataDeletionLog>(`${DATA_DELETION}/users/${id}`, {
      confirm_email: confirmEmail,
    })
    .then((res) => res.data);
};

export const getDataDeletionLogs = () => {
  return http
    .get<IDataDeletionLog[]>(`${DATA_DELETION}/logs`)
    .then((res) => res.data);
};
